import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [ 'panel', 'count', 'combobox' ]

  connect() {
    this.refresh = this.refresh.bind(this)
    this.element.addEventListener('change', this.refresh)
    this.element.addEventListener('input', this.refresh)
    this.refresh()
  }

  disconnect() {
    this.element.removeEventListener('change', this.refresh)
    this.element.removeEventListener('input', this.refresh)
  }

  toggle() {
    this.panelTarget.classList.toggle('d-none')
    this.element.classList.toggle('routes-options--open', !this.panelTarget.classList.contains('d-none'))
  }

  reset() {
    this.checkboxes().forEach(input => { input.checked = input.dataset.defaultChecked === 'true' })
    this.fields().forEach(input => { input.value = input.dataset.defaultValue })
    this.comboboxTargets.forEach(component => {
      const reset = component.querySelector('.combobox__multiple__reset')
      if (reset) reset.click()
    })
    this.panelTarget.classList.add('d-none')
    this.element.classList.remove('routes-options--open')
    // The comboboxes empty themselves on React's next render
    setTimeout(this.refresh)
  }

  preset(event) {
    const { presetField, presetCheckbox, presetDirection, presetDays, presetMonths } = event.currentTarget.dataset
    const sign = presetDirection === 'past' ? -1 : 1
    const date = presetDirection === 'past' ? new Date() : this.periodEnd()

    // Month shifts stop at the target month's last day (31 March − 1 month = 28 February)
    const day = date.getDate()
    date.setDate(1)
    date.setMonth(date.getMonth() + sign * Number(presetMonths))
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
    date.setDate(Math.min(day, lastDay) + sign * Number(presetDays))

    this.element.querySelector(`#${presetField}`).value = this.isoDate(date)
    this.element.querySelector(`#${presetCheckbox}`).checked = true
    this.refresh()
  }

  periodEnd() {
    const picker = this.element.querySelector('#period')?._flatpickr
    const dates  = picker ? picker.selectedDates : []
    return dates.length ? new Date(dates[dates.length - 1]) : new Date()
  }

  isoDate(date) {
    const pad = number => String(number).padStart(2, '0')
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
  }

  refresh() {
    const panel   = this.panelTarget
    const changed = this.checkboxes(panel).filter(input => input.checked !== (input.dataset.defaultChecked === 'true')).length +
      this.fields(panel).filter(input => input.value !== input.dataset.defaultValue).length +
      this.comboboxTargets.filter(component => panel.contains(component) && component.querySelector('input[type=hidden][value]:not([value=""])')).length

    this.countTarget.textContent = changed
    this.countTarget.classList.toggle('d-none', changed === 0)
  }

  checkboxes(scope = this.element) {
    return Array.from(scope.querySelectorAll('input[type=checkbox][data-default-checked]'))
  }

  fields(scope = this.element) {
    return Array.from(scope.querySelectorAll('input[data-default-value]'))
  }
}
